import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-[#1F2A44] pt-20 pb-10">
      <div className="max-w-[1440px] mx-auto px-20">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-10">
          <div>
            <img
              src="https://static.readdy.ai/image/577c45d6defa6ac02f4bf39c73856fa0/c46a7615a0d0ecdd59932abe918c09f8.png"
              alt="Martell Investment Capital"
              className="h-12 w-auto mb-6 brightness-0 invert"
            />
            <p
              className="text-[14px] text-white/70 mb-6"
              style={{ fontFamily: 'Montserrat, sans-serif' }}
            >
              Disciplined Multifamily Investing
            </p>
            <p
              className="text-[13px] text-white/60"
              style={{ fontFamily: 'Montserrat, sans-serif' }}
            >
              © {new Date().getFullYear()} Martell Investment Capital. All rights reserved.
            </p>
          </div>

          <div>
            <h3
              className="text-[15px] font-semibold text-white mb-1"
              style={{ fontFamily: 'Montserrat, sans-serif' }}
            >
              Quick Links
            </h3>
            <div className="w-8 h-0.5 bg-[#B89C4B] mb-5"></div>
            <nav className="flex flex-col space-y-3.5">
              <Link
                to="/"
                className="text-[14px] text-white/80 hover:text-[#B89C4B] transition-colors cursor-pointer"
                style={{ fontFamily: 'Montserrat, sans-serif' }}
              >
                Home
              </Link>
              <Link
                to="/about"
                className="text-[14px] text-white/80 hover:text-[#B89C4B] transition-colors cursor-pointer"
                style={{ fontFamily: 'Montserrat, sans-serif' }}
              >
                About
              </Link>
              <Link
                to="/strategy"
                className="text-[14px] text-white/80 hover:text-[#B89C4B] transition-colors cursor-pointer"
                style={{ fontFamily: 'Montserrat, sans-serif' }}
              >
                Strategy
              </Link>
              <Link
                to="/portfolio"
                className="text-[14px] text-white/80 hover:text-[#B89C4B] transition-colors cursor-pointer"
                style={{ fontFamily: 'Montserrat, sans-serif' }}
              >
                Portfolio
              </Link>
              <Link
                to="/investors"
                className="text-[14px] text-white/80 hover:text-[#B89C4B] transition-colors cursor-pointer"
                style={{ fontFamily: 'Montserrat, sans-serif' }}
              >
                Investors
              </Link>
              <Link
                to="/community"
                className="text-[14px] text-white/80 hover:text-[#B89C4B] transition-colors cursor-pointer"
                style={{ fontFamily: 'Montserrat, sans-serif' }}
              >
                Community
              </Link>
              <Link
                to="/contact"
                className="text-[14px] text-white/80 hover:text-[#B89C4B] transition-colors cursor-pointer"
                style={{ fontFamily: 'Montserrat, sans-serif' }}
              >
                Contact
              </Link>
            </nav>
          </div>

          <div>
            <h3
              className="text-[15px] font-semibold text-white mb-1"
              style={{ fontFamily: 'Montserrat, sans-serif' }}
            >
              Contact
            </h3>
            <div className="w-8 h-0.5 bg-[#B89C4B] mb-5"></div>
            <div className="flex flex-col space-y-3">
              <a
                href="mailto:Andrew.Joseph@martellInvestmentCapital.com"
                className="text-[14px] text-white/80 hover:text-[#B89C4B] transition-colors cursor-pointer"
                style={{ fontFamily: 'Montserrat, sans-serif' }}
              >
                Andrew.Joseph@martellInvestmentCapital.com
              </a>
              <a
                href="tel:+12489435541"
                className="text-[14px] text-white/80 hover:text-[#B89C4B] transition-colors cursor-pointer"
                style={{ fontFamily: 'Montserrat, sans-serif' }}
              >
                1-248-943-5541
              </a>
            </div>
          </div>
        </div>

        <div className="pt-10 border-t border-white/15">
          <div className="flex flex-col md:flex-row items-center justify-center space-y-2 md:space-y-0 md:space-x-4">
            <Link
              to="/contact"
              className="text-[12px] text-white/60 hover:text-[#B89C4B] transition-colors cursor-pointer"
              style={{ fontFamily: 'Montserrat, sans-serif' }}
            >
              Privacy Policy
            </Link>
            <span className="hidden md:inline text-[#B89C4B]">•</span>
            <Link
              to="/contact"
              className="text-[12px] text-white/60 hover:text-[#B89C4B] transition-colors cursor-pointer"
              style={{ fontFamily: 'Montserrat, sans-serif' }}
            >
              Terms of Service
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;